import useTranslation from 'next-translate/useTranslation';

//hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';

// Components
import CompoundBanner from '@/components/base/InfoBanner/CompoundBanner';
import Badge from '@/components/base/Badge';

export function SocialProfilesGroupFirstStatsBanner() {
    const { t } = useTranslation('commons');
    const { activeGroup } = useActiveGroup();
    const socialProfileFirstStatLoading = Boolean(
        activeGroup.social_profiles.find(
            (socialProfile) =>
                !socialProfile.first_stats && !socialProfile.full_stats && socialProfile.active
        )
    );

    if (socialProfileFirstStatLoading) {
        return (
            <CompoundBanner type="info">
                <CompoundBanner.Icon>
                    <Badge variant="info" />
                </CompoundBanner.Icon>
                <CompoundBanner.Content
                    title={t('group_first_stats_banner.title')}
                    message={t('group_first_stats_banner.message')}
                />
            </CompoundBanner>
        );
    }

    return null;
}
